package com.essntl.core.gpt.data

import com.aallam.openai.api.chat.ChatCompletionRequest
import com.aallam.openai.api.chat.ChatMessage
import com.aallam.openai.api.chat.ChatRole
import com.aallam.openai.api.model.ModelId
import com.aallam.openai.client.OpenAI
import com.essntl.config.EssntlConfig
import com.essntl.core.gpt.domain.OpenAIClient

internal class OpenAIClientImpl : OpenAIClient {
    override suspend fun rewriteDescription(description: String): Result<String> {
        val openAI = OpenAI(token = EssntlConfig.openAIKey)

        val chatCompletionRequest =
            ChatCompletionRequest(
                model = ModelId("gpt-4.1-mini"),
                messages =
                    listOf(
                        ChatMessage(
                            role = ChatRole.System,
                            content =
                                "Your goal is to produce a concise, captivating, and luxurious description that" +
                                    "is visually easy to read and appealing to a sophisticated audience.",
                        ),
                        ChatMessage(
                            role = ChatRole.User,
                            content =
                                "Rewrite the provided activity description in HTML format, targeting upscale clients " +
                                    "with luxurious tastes. Your output should be exclusively minified HTML, " +
                                    "containing no other text. Use only these simple HTML tags: " +
                                    "<p>, <span>, <ul>, <li>, and <ol>. " +
                                    "Apply font-weight and font-style to the <span> tag for bold and italic text, " +
                                    "but do not alter the font size.\n" +
                                    "Incorporate bullet points effectively using <ul> and <ol> to enhance readability. " +
                                    "Correctly use and format currency symbols in any mentioned prices." +
                                    "Use only the information provided in the description, do no invent things or invent prices. " +
                                    "Your output should be roughly the same length as the description provided." +
                                    "The final HTML should be concise, visually appealing, and exude luxury, " +
                                    "designed to attract a sophisticated and high-profile clientele. " +
                                    "The description you output should be in the same language as the description provided. " +
                                    "Or it should be in the language instructed in the description provided. " +
                                    "Remember, the HTML should be minified, focusing on brevity and cleanliness in the code. " +
                                    "The description is the following:" +
                                    description,
                        ),
                    ),
            )
        val content = openAI.chatCompletion(chatCompletionRequest).choices[0].message.content
        val response =
            content
                ?.replace("```", "")
                ?.replace("html", "")
                ?.trim()

        return if (response != null) {
            Result.success(response)
        } else {
            Result.failure(
                Throwable(
                    "Sorry could not generate description",
                ),
            )
        }
    }
}
